/**
 * @generated SignedSource<<aa9c94dba76c87acd374062b5b4b0438>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteSprintGoalInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DeleteSprintGoalMutation$variables = {
  input: DeleteSprintGoalInput;
};
export type DeleteSprintGoalMutation$data = {
  readonly deleteSprintGoal: {
    readonly deletedSprintGoalId: string | null;
  } | null;
};
export type DeleteSprintGoalMutation = {
  variables: DeleteSprintGoalMutation$variables;
  response: DeleteSprintGoalMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteSprintGoalPayload",
    "kind": "LinkedField",
    "name": "deleteSprintGoal",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedSprintGoalId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteSprintGoalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteSprintGoalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0c17bac4cccc4287850e4ed0a5d740f4",
    "id": null,
    "metadata": {},
    "name": "DeleteSprintGoalMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteSprintGoalMutation(\n  $input: DeleteSprintGoalInput!\n) {\n  deleteSprintGoal(input: $input) {\n    deletedSprintGoalId\n  }\n}\n"
  }
};
})();

(node as any).hash = "7a15d43aafe08091b14070ce1d097112";

export default node;
